"use client"

import { zIndex } from "@nova/constants"
import { ReactNode, useEffect, useState } from "react"
import { createPortal } from "react-dom"

const elementId = "portalled-tooltip-root"
const offsetX = 16
const offsetY = 0

export function PortalledTooltipRoot() {
    return <div id={elementId} />
}

export function PortalledTooltip({
    children,
    initialPosition = { x: 0, y: 0 },
}: {
    children: ReactNode
    initialPosition?: { x: number; y: number }
}) {
    const [mounted, setMounted] = useState(false)
    const [pos, setPos] = useState({
        x: initialPosition.x + offsetX,
        y: initialPosition.y + offsetY,
    })

    useEffect(() => {
        setMounted(true)
        const handleMove = (e: MouseEvent) => {
            setPos({
                x: e.clientX + offsetX,
                y: e.clientY + offsetY,
            })
        }
        window.addEventListener("mousemove", handleMove)
        return () => window.removeEventListener("mousemove", handleMove)
    }, [])

    if (!mounted) return null

    const root = document.getElementById(elementId)
    if (!root) return null

    return createPortal(
        <div
            style={{
                position: "fixed",
                left: pos.x,
                top: pos.y,
                pointerEvents: "none",
                zIndex: zIndex.PortalledTooltip,
            }}
            className="tooltip"
        >
            {children}
        </div>,
        root
    )
}
